import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserGroupService } from '../../service/user-group.service';
import { removeUndefined } from 'na-lib';

@Component({
    selector: 'app-user-group-edit-dialog',
    templateUrl: './user-group-edit-dialog.component.html',
    styleUrl: './user-group-edit-dialog.component.css',
    standalone: false
})

export class UserGroupEditDialogComponent {
  userGroupForm!:FormGroup
  userGroupData:any
  option:string

    constructor(public dialogRef: MatDialogRef<UserGroupEditDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private fb: FormBuilder,
      private userGroupService:UserGroupService
    ){
      dialogRef.disableClose = true;
    }

  ngOnInit():void{
    let displayName, creationDate, id
    if(this.data){
      this.option = 'edit'
      displayName = this.data.displayName
      creationDate = this.data.creationDate
      id = this.data.id
    }else
      this.option = 'create'
    
    this.userGroupForm = this.fb.group({
      displayName:[{value: displayName ? displayName : undefined, disabled:false}],
      creationDate:[{value: creationDate ? creationDate : undefined, disabled:false}],
      id:[{value: id ? id : undefined, disabled:false}]
    })

  }

  onSave(){
    const data = this.userGroupForm.value
    removeUndefined(data)
    try{
      if(this.option=='create'){
        this.userGroupService.createUserGroup(data).then( value => {
          this.dialogRef.close([true, data])
        })
      }

      if(this.option=='edit'){
        this.userGroupService.updateUserGroup(data, data.id).then( value => {
          this.dialogRef.close([true, data])
        })
      }

    }catch(error) {
      console.log(error)
    }
  }

  onCancel(){
    this.dialogRef.close([false, this.userGroupData])
  }
}
